import type { UserQueryParams, User, PaginatedUsers } from '@/types/User'

import ky from './httpService'

export async function listUsers(queryParams: UserQueryParams): Promise<PaginatedUsers> {
  const searchParams = new URLSearchParams()
  if (queryParams.limit) searchParams.append('itemsPerPage', queryParams.limit.toString())
  if (queryParams.offset) searchParams.append('page', queryParams.offset.toString())

  return JSON.parse(await ky.get('api/auth0/user', { searchParams }).json()) as PaginatedUsers
}

export async function editUser(user: User) {
  if (user.user_metadata === undefined) user.user_metadata = {}
  user.user_metadata.family_name = user.family_name
  user.user_metadata.given_name = user.given_name
  user.family_name = undefined
  user.given_name = undefined
  user.UserMetadata = {
    // asp things
    FamilyName: user.user_metadata.family_name,
    GivenName: user.user_metadata.given_name
  }
  return ky.patch('api/auth0/user/' + user.user_id, { json: user })
}

export async function getUser(userId: string) {
  return JSON.parse(await ky.get('api/auth0/user/' + userId).json())
}

export async function updateUserAttributes(user: User) {
  const payload = {
    Email: user.email,
    FamilyName: user.family_name,
    GivenName: user.given_name,
    UserMetadata: user.UserMetadata
  }
  return ky.patch('api/auth0/user/profile', { json: payload })
}

export async function deleteUser(user: User) {
  return ky.delete('api/auth0/user', { json: [user.user_id] })
}

export async function inviteUser(user: User) {
  return ky.post('api/auth0/invitations', {
    json: {
      emails: user.email,
      roles: ['rol_8hSaL6DKlSgyZTfM']
    }
  })
}

export async function resetPassword(email: string) {
  return ky.post('newapi/User/resetpassword', {
    json: email
  })
}

export async function listAvailableUserRoles() {
  return ky.get('api/auth0/user/roles/').json()
}

export async function getUserRoles(user: User) {
  return ky.get('api/auth0/user/getUserRoles/' + user.user_id).json()
}

export async function updateUserRoles(userId: string, roles: string[]) {
  if (roles.length === 0) return
  // if roles[0] is an object, map all object to .id
  if (typeof roles[0] === 'object') roles = (roles as unknown as { id: string }[]).map((role) => role.id)
  return ky.patch('api/auth0/user/roles/' + userId, { json: roles })
}

// Requested once and shared by everything that needs it on load
let userAccessLevel: Promise<string[]> | undefined

export function getUserAccessLevel(): Promise<string[]> {
  userAccessLevel ??= ky
    .get('api/organizationHierarchy/user')
    .json<string[]>()
    .catch((error) => {
      // Let the next call retry
      userAccessLevel = undefined
      throw error
    })
  return userAccessLevel
}
